import React, { useEffect, useRef } from 'react';
import { Settings, LogOut } from 'lucide-react';

const UserMenuPopover = ({ isOpen, email, onSettings, onLogout, onClose, className = 'absolute bottom-16 left-3' }) => {
    const popoverRef = useRef(null);

    useEffect(() => {
        if (!isOpen) return;

        const handleClick = (e) => {
            const isInside = popoverRef.current?.contains(e.target);

            if (!isInside) {
                onClose?.();
            }
        };

        const timer = setTimeout(() => {
            document.addEventListener('click', handleClick);
        }, 0);

        return () => {
            clearTimeout(timer);
            document.removeEventListener('click', handleClick);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div
            ref={popoverRef}
            className={`${className} z-[9998] w-60 bg-app-bg border border-app-border rounded-xl shadow-xl overflow-hidden`}
        >
            <div className="px-4 py-3 text-sm text-gray-700 border-b border-app-border">
                <div className="truncate font-medium">{email}</div>
            </div>
            <div className="py-1">
                <button
                    onClick={() => {
                        onClose?.();
                        onSettings?.();
                    }}
                    className="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-800 hover:bg-[#0000000c]"
                >
                    <Settings className="w-4 h-4" />
                    <span>Settings</span>
                </button>
                <button
                    onClick={() => { onClose?.(); onLogout?.(); }}
                    className="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-800 hover:bg-[#0000000c]"
                >
                    <LogOut className="w-4 h-4" />
                    <span>Log out</span>
                </button>
            </div>
        </div>
    );
};

export default UserMenuPopover;
